
import * as types from './types';

/* eslint-disable import/prefer-default-export */
export const setComparisonInterval = (from, to) => ({
  type: types.SET_COMPARISON_INTERVAL,
  from,
  to,
});

export const setComparisonUnavailable = (from, to) => ({
  type: types.COMPARISON_UNAVAILABLE,
  from,
  to,
});
